import { render, staticRenderFns } from "./TurnCkeditor.vue?vue&type=template&id=74b124b6"
import script from "./TurnCkeditor.vue?vue&type=script&lang=js"
export * from "./TurnCkeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports